// import i18n from "i18next";
import { appWithTranslation, Trans, useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { I18nextProvider, initReactI18next } from "react-i18next";
import i18n from "./i18n";

import I18nStorybookChangeLanguage from "./i18n-test";

//TODO: Прверить перфоманс хука из next-i18next
// import { useTranslation } from "./hooks/useTranslations";

import { i18nConfig } from "./config";

const initializeTranslations = (): Promise<Function> => {
  return i18nConfig();
};

export {
  initializeTranslations,
  I18nStorybookChangeLanguage,
  I18nextProvider,
  initReactI18next,
  i18n,
  useTranslation,
  Trans,
  appWithTranslation,
  serverSideTranslations,
};
